export const environment = {
  name: 'gpsguardian-production',
  production: true,
  apiUrl: 'https://geotikapi.gpsguardian.pl/',
  cacheLifeTime: 30 * 60 * 1000,
  mapboxApiKey: 'pk.eyJ1IjoicmFmYWxhbGVrc2FuZHJ6YWtnZW90aWsiLCJhIjoiY2s3dnd5aXozMGR3MTNvcXEzemZzeDM5MCJ9.iYY45HzWped5y-bKV2aThQ',
  googleMapsApiKey: 'AIzaSyBtr_3iitGgXx3ELtPFyVjJ5pbHaM_9bVU',
  googleMapsVectorId: 'af5598fed3f9259b',
  googleMapsRasterId: '515d13c140795b79',
  appName: 'New GPS Guardian',
  storagePrefix: 'geotik',
  vapidKey: 'BElhcxiTiPKOMbfjwBBgSQnrpugyuETCuzDZxoTTAuhgz0LRrJvSJ671_MKvJHXs9KouXZQd9Qs37OMov6UuU08',
  firebaseConfig: {
    apiKey: "AIzaSyBP_WWpMR2U2Mt-QgB3U1HGmni3JH4jbxc",
    authDomain: "gpsguardian-prod.firebaseapp.com",
    projectId: "gpsguardian-prod",
    storageBucket: "gpsguardian-prod.appspot.com",
    messagingSenderId: "787733830690",
    appId: "1:787733830690:web:c9014ae97b921474873e7b",
    vapidKey: 'BElhcxiTiPKOMbfjwBBgSQnrpugyuETCuzDZxoTTAuhgz0LRrJvSJ671_MKvJHXs9KouXZQd9Qs37OMov6UuU08'
  }
};
